import React, {FC} from 'react';

import {ConversationSubjectModel} from '../../../../../store/data/conversations/conversationSubjectSelectors';
import {MutationProofText} from '../../../../common/text/mutationProofText';

/*
 * Props.
 */

export interface ConversationSubjectProps {
  subject: ConversationSubjectModel;
}

/*
 * Component.
 */

export const ConversationSubject: FC<ConversationSubjectProps> = (props) => {
  const {text, isPlaceholder} = props.subject;

  const subjectRender = isPlaceholder ? <em>{text}</em> : text;
  return <MutationProofText>{subjectRender}</MutationProofText>;
};
